// extracted by css-extract-rspack-plugin
export default {"DashboardGridContainer":"feX86","isFixedWidth":"fLouu","DashboardCardContainer":"X3_A9","isAnimationDisabled":"v23be","Card":"xH0n9"};